var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOp2Mise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 71,
    viewBox: "0 0 195 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3365_12629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7997 35.4914C26.7997 39.7917 23.0304 43.2889 18.3977 43.2889C13.7649 43.2889 10 39.7917 10 35.4914C10 31.1911 13.7692 27.6938 18.402 27.6938C23.0348 27.6938 26.7997 31.1954 26.7997 35.4914ZM24.8956 35.4914C24.8956 32.1496 21.9813 29.4295 18.402 29.4295C14.8184 29.4295 11.9084 32.1496 11.9084 35.4914C11.9084 38.8332 14.8227 41.5533 18.402 41.5533C21.9813 41.5576 24.8956 38.8375 24.8956 35.4914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2104 32.2748C53.2104 32.9095 53.0722 33.5053 52.7959 34.045C52.5196 34.589 52.118 35.0596 51.5999 35.4482C51.0991 35.8238 50.4946 36.1174 49.8038 36.3204C49.1346 36.5146 48.379 36.614 47.563 36.614H43.5088V43.0515H41.6047V27.9399H47.563C48.3833 27.9399 49.1346 28.0392 49.8038 28.2335C50.4946 28.4321 51.0991 28.7257 51.5956 29.0971C52.1137 29.4856 52.5196 29.9562 52.7959 30.5003C53.0765 31.0313 53.2147 31.6315 53.2104 32.2748ZM51.3106 32.2748C51.3106 31.8819 51.2329 31.5365 51.0732 31.2213C50.9177 30.9104 50.6932 30.6557 50.3953 30.4312C50.0801 30.198 49.6872 30.0124 49.2296 29.8785C48.7503 29.7404 48.189 29.667 47.5673 29.667H43.5131V34.8783H47.5673C48.189 34.8783 48.746 34.8049 49.2296 34.6667C49.6872 34.5329 50.0801 34.3472 50.391 34.1141C50.6889 33.8896 50.9134 33.6262 51.0689 33.3153C51.2329 33.0001 51.3106 32.6591 51.3106 32.2748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.145 43.0471H115.232L114.282 34.2478C114.11 32.646 114.213 31.001 114.213 31.001C114.213 31.001 113.626 32.6547 112.931 34.0838L108.92 42.3217L104.909 34.0838C104.214 32.659 103.627 31.001 103.627 31.001C103.627 31.001 103.73 32.646 103.558 34.2522L102.608 43.0471H100.695L102.323 27.9355H103.998L108.92 38.0387L113.842 27.9355H115.522L117.145 43.0471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.036 43.0471V27.9355H133.94V43.0471H132.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.299 39.006C160.334 40.1199 159.893 41.1173 159.025 41.8858C158.011 42.7882 156.504 43.2933 154.846 43.2933C154.725 43.2933 154.604 43.289 154.483 43.2847C151.608 43.1595 149.298 41.5274 148.59 39.1269L150.433 38.6778C151.025 40.6898 152.959 41.4843 154.574 41.5533C155.826 41.6095 156.992 41.2684 157.691 40.6467C158.175 40.2192 158.408 39.6795 158.391 39.0535C158.339 37.3308 156.595 36.6227 154.656 35.9966C154.393 35.9103 154.155 35.8326 153.952 35.7592C153.844 35.7203 153.723 35.6771 153.59 35.6339C152.16 35.1417 149.186 34.1142 149.406 31.3984C149.548 29.6152 151.18 27.6982 154.423 27.6982C156.996 27.6982 158.892 28.7863 159.764 30.7637L157.994 31.407C157.415 30.0945 156.215 29.4296 154.423 29.4296C154.393 29.4296 151.47 29.4512 151.306 31.5236C151.202 32.8405 152.709 33.4752 154.263 34.0105C154.41 34.0623 154.544 34.1098 154.665 34.153C154.846 34.2178 155.062 34.2912 155.295 34.3646C157.013 34.9172 160.204 35.9491 160.299 39.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.03 29.6669V34.5501H184.447V36.2814H177.03V41.3157H185V43.0471H175.419H175.121V27.9355H175.419H185V29.6669H177.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6661 42.8834C75.4977 42.8834 75.3336 42.8186 75.2084 42.6934C74.958 42.4386 74.958 42.0285 75.2127 41.7781C75.9122 41.0872 76.6116 40.4094 77.3024 39.7402C82.2158 34.9951 86.4557 30.9021 84.4394 25.9541C81.3523 18.6963 68.6543 22.1245 68.5248 22.1633C68.1794 22.2583 67.821 22.0554 67.726 21.7143C67.6311 21.3689 67.834 21.0148 68.1751 20.9155C68.7407 20.7558 82.0993 17.1506 85.631 25.4576C87.9841 31.2259 83.2305 35.8155 78.2005 40.6728C77.514 41.3333 76.8189 42.0069 76.1237 42.6977C75.9942 42.8186 75.8301 42.8834 75.6661 42.8834Z",
    fill: "url(#paint0_linear_3365_12629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0482 43.0471C66.9014 43.0471 66.7503 42.9953 66.6294 42.896C66.3574 42.6629 66.3229 42.257 66.5517 41.985C68.7278 39.416 70.9729 37.1536 72.9503 35.1546C75.2516 32.8317 78.1142 29.9476 77.8378 29.1618C77.1039 27.8924 72.687 28.4537 69.764 29.2611C69.4186 29.3561 69.0602 29.1532 68.9652 28.8078C68.8702 28.4624 69.0732 28.1083 69.4143 28.009C70.7657 27.6334 77.5702 25.9064 78.9906 28.5746L79.0122 28.6178C79.6987 30.1808 77.5054 32.3957 73.87 36.0613C71.9055 38.0431 69.6819 40.2839 67.5404 42.814C67.4152 42.9694 67.2339 43.0471 67.0482 43.0471Z",
    fill: "url(#paint1_linear_3365_12629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9532 50.0936H64.6088C64.2505 50.0936 63.9612 49.8043 63.9612 49.446C63.9612 49.0876 64.2505 48.7983 64.6088 48.7983H84.9532C85.3116 48.7983 85.6009 49.0876 85.6009 49.446C85.6009 49.8043 85.3073 50.0936 84.9532 50.0936Z",
    fill: "url(#paint2_linear_3365_12629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7835 39.1961C72.6437 40.3274 71.4607 41.4974 70.3252 42.6847C70.2 42.8186 70.0272 42.8834 69.8589 42.8834C69.6991 42.8834 69.535 42.8229 69.4098 42.702C69.1508 42.4559 69.1421 42.0457 69.3882 41.7867C70.5367 40.5907 71.7197 39.412 72.8682 38.2765C77.2376 33.9417 81.3652 29.8443 79.8886 27.8582C77.7514 24.5596 69.6862 26.9256 66.4825 28.2122C66.4998 28.1259 66.5127 28.0309 66.5127 27.9402C66.5127 27.556 66.3444 27.2192 66.081 26.9817C67.985 26.2348 78.0104 22.5778 80.9507 27.1199C83.0793 29.9738 78.7703 34.2439 73.7835 39.1961ZM66.0853 26.9774C65.8565 26.7702 65.5542 26.6406 65.2218 26.6406C64.5051 26.6406 63.9265 27.2192 63.9265 27.9359C63.9265 28.6526 64.5051 29.2312 65.2218 29.2312C65.8435 29.2312 66.3616 28.7951 66.4868 28.2079C66.5041 28.1216 66.5171 28.0266 66.5171 27.9359C66.5171 27.5516 66.3487 27.2149 66.0853 26.9774Z",
    fill: "url(#paint3_linear_3365_12629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1315 42.5592L72.9718 42.7103C72.8465 42.8269 72.6868 42.883 72.5314 42.883C72.3587 42.883 72.1859 42.8139 72.0564 42.6758C71.8146 42.4124 71.8276 42.0022 72.091 41.7604L72.2507 41.6093C78.3601 35.936 84.1327 30.5736 82.138 26.6835C79.5647 22.1025 70.4114 24.3563 68.2656 24.9607C68.3131 24.8226 68.3433 24.6801 68.3433 24.529C68.3433 24.2052 68.2181 23.9116 68.0195 23.6827C70.5712 22.966 80.2382 20.6648 83.2778 26.0704C85.7302 30.8586 79.6122 36.5405 73.1315 42.5592ZM68.0238 23.6827C67.7863 23.4107 67.4409 23.2337 67.0524 23.2337C66.3356 23.2337 65.7571 23.8123 65.7571 24.529C65.7571 25.2457 66.3356 25.8243 67.0524 25.8243C67.6136 25.8243 68.0886 25.4616 68.2699 24.9607C68.3174 24.8226 68.3476 24.6801 68.3476 24.529C68.3433 24.2052 68.2224 23.9116 68.0238 23.6827Z",
    fill: "url(#paint4_linear_3365_12629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6413 46.9935C86.6413 47.231 86.7104 47.4512 86.8226 47.6411H66.245C65.8867 47.6411 65.5974 47.3519 65.5974 46.9935C65.5974 46.6352 65.8867 46.3459 66.245 46.3459H86.8226C86.7104 46.5359 86.6413 46.756 86.6413 46.9935ZM87.9365 45.6982C87.4573 45.6982 87.0471 45.9616 86.8226 46.3459C86.7104 46.5359 86.6413 46.756 86.6413 46.9935C86.6413 47.231 86.7104 47.4512 86.8226 47.6411C87.0471 48.0254 87.4616 48.2888 87.9365 48.2888C88.6533 48.2888 89.2318 47.7102 89.2318 46.9935C89.2318 46.2768 88.6533 45.6982 87.9365 45.6982Z",
    fill: "url(#paint5_linear_3365_12629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6578 44.6058C83.6578 44.8433 83.7269 45.0635 83.8391 45.2535H64.2028C63.8445 45.2535 63.5552 44.9642 63.5552 44.6058C63.5552 44.2475 63.8445 43.9582 64.2028 43.9582H83.8391C83.7226 44.1525 83.6578 44.3684 83.6578 44.6058ZM84.9531 43.3105C84.4738 43.3105 84.0637 43.5739 83.8391 43.9582C83.7269 44.1482 83.6578 44.3684 83.6578 44.6058C83.6578 44.8433 83.7269 45.0635 83.8391 45.2535C84.0637 45.6377 84.4781 45.9011 84.9531 45.9011C85.6698 45.9011 86.2484 45.3225 86.2484 44.6058C86.2484 43.8934 85.6655 43.3105 84.9531 43.3105Z",
    fill: "url(#paint6_linear_3365_12629)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3365_12629",
    x1: 76.973,
    y1: 42.8824,
    x2: 76.973,
    y2: 20.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3365_12629",
    x1: 72.773,
    y1: 43.0457,
    x2: 72.773,
    y2: 27.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3365_12629",
    x1: 63.9591,
    y1: 49.4471,
    x2: 85.599,
    y2: 49.4471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3365_12629",
    x1: 72.7173,
    y1: 42.8824,
    x2: 72.7173,
    y2: 24.8784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3365_12629",
    x1: 74.7934,
    y1: 42.882,
    x2: 74.7934,
    y2: 22.5819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3365_12629",
    x1: 65.5949,
    y1: 46.993,
    x2: 90.604,
    y2: 46.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3365_12629",
    x1: 63.5497,
    y1: 44.6069,
    x2: 88.2193,
    y2: 44.6069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3365_12629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 30.0935,
    fill: "white",
    transform: "translate(10 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp2Mise);
export default __webpack_public_path__ + "static/media/op2mise.b5108f2d7cde155b87ec1af564892d68.svg";
export { ForwardRef as ReactComponent };